import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { INotifyOfDeleteOptions } from '../../../entity-master/components/master-list-item/master-list-item.component';
import {
  IMasterListItemAction,
  IMasterListItemData,
} from '../../../entity-master/components/master-list-item/master-list-item.interface';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { IHomeSearchRouteData } from '../../../home-data/home-data.data';
import { Highlight } from '../../../search-data/sub-models/highlight.model';
import { IRouter } from '../../../shared/interfaces/router.interface';
import { TrackedTime } from '../../../tracked-time-data/models/tracked-time.model';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingInputTypeValuesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { TrackedTimeListItemBuilder } from './tracked-time-list-item.builder';
import { take } from 'rxjs/operators';
import { SearchDataStore } from '../../../search-data/search-data.store';
import { NavigationService } from '../../../navigation/navigation.service';

@Component({
  selector: 'app-tracked-time-list-item',
  templateUrl: 'tracked-time-list-item.component.html',
  styleUrls: ['tracked-time-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [TrackedTimeListItemBuilder],
})
export class TrackedTimeListItemComponent implements OnInit {
  @Input() trackedTime: TrackedTime;
  @Input() position: number; // 1-index
  @Input() listFilter: string;
  @Input() highlights: List<Highlight>;
  @Input() displayStatus = false;

  @Output()
  onAction: EventEmitter<IMasterListItemAction> = new EventEmitter<IMasterListItemAction>();

  route: IRouter;
  featureName: string;
  trackingScreenName: TrackingScreenNamesEnum;
  notifyOfDeleteOptions: INotifyOfDeleteOptions;
  trackedTimeData: List<IMasterListItemData>;
  trackedTimeActions: List<List<IMasterListItemAction>>;

  constructor(
    private _route: ActivatedRoute,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _navigationService: NavigationService,
    private _searchDataStore: SearchDataStore,
    private _trackedTimeListItemBuilder: TrackedTimeListItemBuilder
  ) {}

  ngOnInit() {
    this._searchDataStore
      .getGlobalSearchParams()
      .pipe(take(1))
      .subscribe((globalSearchParams) => {
        const routeData = this._route.snapshot.data as IHomeSearchRouteData;
        const inGlobalSearch: boolean = routeData.inGlobalSearch;
        const trackedTime = this.trackedTime;
        const trackedTimeId: string = this.trackedTime.id;
        this.trackingScreenName = this._navigationService.activeRouteName;
        const trackingAction: ITrackingAction = inGlobalSearch
          ? this._trackingActionBuilder.buildResultTapped(
              routeData.type,
              this.position,
              this.trackingScreenName,
              globalSearchParams.query
            )
          : this._trackingActionBuilder.buildTapped(this.trackingScreenName);
        const trackingObject: ITrackingObject = this._trackingObjectBuilder.buildInput(
          trackedTimeId || null,
          trackedTime.localId,
          TrackingInputTypeValuesEnum.tracked_time
        );
        const highlight: Highlight = (this.highlights || List()).find(
          (hLight: Highlight) => trackedTimeId === hLight.refId
        );

        this.featureName = Toggles.KEYS.TIME_TRACKING;
        this.notifyOfDeleteOptions = this._trackedTimeListItemBuilder.buildNotifyOnDeleteOptions(
          trackedTime
        );
        this.trackedTimeData = this._trackedTimeListItemBuilder.buildListItemData(
          trackedTime,
          this.displayStatus,
          highlight
        );
        this.trackedTimeActions = this._trackedTimeListItemBuilder.buildListItemActions(
          trackedTime,
          trackingObject,
          this.trackingScreenName
        );
        this.route = this._trackedTimeListItemBuilder.buildListItemRoute(
          trackingAction,
          inGlobalSearch
            ? this._trackingObjectBuilder.buildGlobalSearch()
            : trackingObject,
          this.trackedTime.id,
          this.position
        );
      });
  }
}
